import { call, put, takeEvery } from 'redux-saga/effects';
import {
    editLocationCriteriaSuccess,
    editLocationCriteriaFailure,
} from '../actions/edit_location_criteria.actions';
import { EDIT_LOCATION_CRITERIA_REQUEST } from '../constants/update_location_criteria.constants';
import { message_error, message_success } from '../../../../../components/Message';
import { editLocationCriteria } from '../../requests/edit_location_criteria';

function* editLocationCriteriaRequest({ configId, locationCriteriaId, config }) {
    const changed_config = yield call(editLocationCriteria, configId, locationCriteriaId, config);
    const { result, options } = changed_config;

    if (result) {
        yield put(editLocationCriteriaSuccess(options));
        message_success('Changes saved successfully!');
    } else {
        yield put(editLocationCriteriaFailure('Something gone wrong!'));
        message_error('Something gone wrong!');
    }
}

export default function* editLocationCriteriaSaga() {
    yield takeEvery(EDIT_LOCATION_CRITERIA_REQUEST, editLocationCriteriaRequest);
}



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Lead-o-matic_location_update/redux/sagas/edit_location_criteria.saga.js